var _rect, _rect2, _rect3, _rect4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppsScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ea4335",
    x: 27.53,
    y: 328.9,
    width: 373,
    height: 107,
    rx: 53.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fbbc04",
    x: 53.33,
    y: 250.94,
    width: 373,
    height: 107,
    rx: 53.5,
    transform: "translate(254.91 691.72) rotate(-144)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#34a853",
    x: 120.53,
    y: 201.9,
    width: 373,
    height: 107,
    rx: 53.5,
    transform: "translate(455.05 -115.53) rotate(72)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#4285f4",
    x: 202.53,
    y: 201.9,
    width: 373,
    height: 107,
    rx: 53.5,
    transform: "translate(25.92 546.46) rotate(-72)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 265.84,
    cy: 129.28,
    r: 26.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.44,
    cy: 225.44,
    r: 26.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.36,
    cy: 382.6,
    r: 26.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.22,
    cy: 381.64,
    r: 26.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.67,
    cy: 127.89,
    r: 26.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsScript);
export default __webpack_public_path__ + "static/media/appsScript.b7612f67b79bcde8a25390c35e5a501d.svg";
export { ForwardRef as ReactComponent };